import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getBrandsFrontEnd } from "../../reducers/commonReducer";


const ValuedPartners = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBrandsFrontEnd());

   
  }, [dispatch, navigate]);

  const { getBrandsFrontEndData } = useSelector((state) => state.commonReducer);

  return (
    <div className="valued-partners py-5 bg-white text-center">
      <div className="container">
        <h2 className="fw-bold mb-4">Valued Partners</h2>
        <div className="row justify-content-center align-items-center g-4">
          {!!getBrandsFrontEndData?.list &&
            getBrandsFrontEndData.list.map((data, index) => (
              <div className="col-4 col-md-2" key={index}>
                <img
                  className="img-fluid partner-logo grayscale"
                  src={data?.image}
                  alt={data?.name}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ValuedPartners;

